import api from '../api/base/index'

export default {
    install(Vue) {
        Vue.prototype.$api = api;
    }
}